<template>
  <div class="container mt-3">
    <div class="row justify-content-start">
      <div class="col-md-8">
        <div class="p-3 border rounded">
          <h5 class="mb-3">意见收集</h5>
          <div class="mb-2"><small class="text-muted">我的昵称：{{ currentUserName || '未登录' }}</small></div>
          <b-form-group label="你的意见" label-for="fb-content">
            <b-form-textarea id="fb-content" v-model="fbContent" rows="5" max-rows="10" placeholder="请输入你的意见或建议"></b-form-textarea>
          </b-form-group>
          <div class="d-flex align-items-center mb-2">
            <b-form-file v-model="fbFile" accept="image/*" browse-text="选择图片" placeholder="可选，上传图片" @input="onUpload"></b-form-file>
          </div>
          <div class="d-flex flex-wrap mb-2">
            <img v-for="(url, idx) in fbImages" :key="idx" :src="url" alt="预览" class="preview-thumb" @click="openImage(url)" />
          </div>
          <b-button variant="primary" size="sm" @click="onSubmit" :disabled="submitting">提交意见</b-button>
          <b-alert :show="fbMsg!==''" variant="info" class="mt-2">{{ fbMsg }}</b-alert>
        </div>
        <div class="mt-3 p-3 border rounded">
          <h6 class="mb-3">大家的意见</h6>
          <div v-for="item in feedbackList" :key="item.id" class="mb-3">
            <div class="mb-1 d-flex align-items-center"><strong>{{ item.username }}</strong> <small class="text-muted ml-2">{{ item.created_time }}</small> <b-button :variant="item.liked_by_me ? 'danger' : 'link'" size="sm" class="ml-3 p-0" @click="toggleFeedbackLike(item)">👍</b-button> <small class="ml-1 text-muted">赞 {{ item.likes || 0 }}</small> <b-button v-if="currentUserId===item.user_id" variant="link" size="sm" class="ml-2 p-0" @click="deleteFeedback(item)"><img :src="deleteIcon" alt="delete" class="thumb-icon" /></b-button></div>
            <div class="mb-1">{{ item.content }}</div>
            <div class="d-flex flex-wrap mb-2">
              <img v-for="(url, idx) in item.images" :key="idx" :src="fullUrl(url)" alt="图片" class="list-thumb" @click="openImage(fullUrl(url))" />
            </div>
            <div class="pl-2">
              <div v-for="c in item.comments" :key="c.id" class="mb-1 d-flex align-items-center">
                <small><strong>{{ c.username }}</strong>：</small>
                <small class="text-muted ml-2">{{ c.created_time }}</small>
                <small class="ml-1">{{ c.content }}</small>
                <b-button :variant="c.liked_by_me ? 'danger' : 'link'" size="sm" class="ml-2 p-0" @click="toggleLike(c)">👍</b-button>
                <small class="ml-1 text-muted">赞 {{ c.likes || 0 }}</small>
                <b-button v-if="currentUserId===c.user_id" variant="link" size="sm" class="ml-2 p-0" @click="deleteComment(c)"><img :src="deleteIcon" alt="delete" class="thumb-icon" /></b-button>
              </div>
              <div class="d-flex align-items-center mt-2">
                <b-form-input v-model="commentInputs[item.id]" size="sm" placeholder="写下你的评论"></b-form-input>
                <b-button variant="link" size="sm" class="ml-2" @click="submitComment(item.id)">评论</b-button>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="imageViewer" title="图片预览" hide-footer centered size="xl">
      <div class="text-center">
        <img :src="imageViewerSrc" alt="图片预览" class="image-large" />
      </div>
    </b-modal>
  </div>
 </template>

 <script>
 import { request_zzquant } from "network/request.js"
 export default {
  data(){
    return { fbContent:'', fbFile:null, fbImages:[], fbMsg:'', submitting:false, feedbackList:[], commentInputs:{}, currentUserId:null, currentUserName:null, deleteIcon: require('assets/img/delete.png'), imageViewerSrc:'' }
  },
  mounted(){ this.loadUser(); this.loadList() },
  methods:{
    onUpload(){
       if(!this.fbFile){ return }
       const form = new FormData()
       form.append('file', this.fbFile)
       request_zzquant({ url: '/feedback/upload', method: 'POST', data: form, headers: { 'Content-Type': 'multipart/form-data' } })
         .then(res => { const url = res.data && res.data.data ? res.data.data.url : null; if(url){ const full = 'https://api.zizizaizai.com' + url; this.fbImages.push(full); this.fbFile=null; } })
         .catch(() => { this.fbMsg = '图片上传失败，请重试'; this.fbFile=null; })
    },
    openImage(url){ this.imageViewerSrc = url; try{ this.$refs.imageViewer.show() }catch(e){ void 0 } },
    loadUser(){
      request_zzquant({ url:'/user/info', method:'GET' }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.currentUserId=d.id||null; this.currentUserName=d.username||null; this.applyLikeMarks() }).catch(()=>{ this.currentUserId=null; this.currentUserName=null; })
    },
     onSubmit(){
       if(!this.fbContent || this.fbContent.trim()===''){ this.fbMsg='请输入意见内容'; return }
       this.submitting=true
       request_zzquant({ url:'/feedback/submit', method:'POST', data:{ content:this.fbContent.trim(), images:this.fbImages } })
         .then(() => { this.fbMsg='提交成功，感谢你的建议！'; this.fbContent=''; this.fbImages=[]; this.submitting=false; this.loadList(); })
         .catch(() => { this.fbMsg='提交失败，请登录后重试'; this.submitting=false; })
     },
    loadList(){
      request_zzquant({ url:'/feedback/list', method:'GET' })
        .then(res => { const data = res.data && res.data.data ? res.data.data : []; this.feedbackList = Array.isArray(data) ? data : []; this.normalizeLikes(); this.applyLikeMarks() })
        .catch(() => {})
    },
    normalizeLikes(){
      const list = Array.isArray(this.feedbackList) ? this.feedbackList : [];
      for(const item of list){ item.liked_by_me = typeof item.liked_by_me==='boolean' ? item.liked_by_me : !!(item.liked || item.my_liked || item.liked_me || item.like_by_me); const cs = Array.isArray(item.comments) ? item.comments : []; for(const c of cs){ c.liked_by_me = typeof c.liked_by_me==='boolean' ? c.liked_by_me : !!(c.liked || c.my_liked || c.liked_me || c.like_by_me) } }
    },
    applyLikeMarks(){
      const uid = this.currentUserId || 0; if(!uid) return;
      const list = Array.isArray(this.feedbackList) ? this.feedbackList : [];
      const itemLiked = this._getLikedSet('fb_item');
      const cLiked = this._getLikedSet('fb_comment');
      for(const item of list){
        if(Array.isArray(item.liked_user_ids)){ item.liked_by_me = item.liked_by_me || item.liked_user_ids.includes(uid) }
        if(itemLiked.has(item.id)) item.liked_by_me = true;
        const cs = Array.isArray(item.comments) ? item.comments : [];
        for(const c of cs){ if(Array.isArray(c.liked_user_ids)){ c.liked_by_me = c.liked_by_me || c.liked_user_ids.includes(uid) } if(cLiked.has(c.id)) c.liked_by_me = true; }
      }
    },
    _getLikedSet(type){
      const uid = this.currentUserId || 0; const key = `zzq_${type}_liked_${uid}`;
      try{ const raw = localStorage.getItem(key) || '[]'; const arr = JSON.parse(raw); if(Array.isArray(arr)) return new Set(arr); }catch(e){ return new Set() }
      return new Set();
    },
    _saveLikedSet(type, set){
      const uid = this.currentUserId || 0; const key = `zzq_${type}_liked_${uid}`; try{ localStorage.setItem(key, JSON.stringify(Array.from(set))) }catch(e){ void 0 }
    },
     submitComment(fid){
       const text = (this.commentInputs[fid] || '').trim(); if(!text){ return }
       request_zzquant({ url:'/feedback/comment', method:'POST', data:{ feedback_id: fid, content: text } })
         .then(() => { this.commentInputs[fid]=''; this.loadList(); })
         .catch(() => {})
     },
     deleteFeedback(item){
       request_zzquant({ url:'/feedback/delete', method:'POST', data:{ feedback_id: item.id } })
         .then(()=>{ this.loadList() })
         .catch(()=>{})
     },
    toggleFeedbackLike(item){
      request_zzquant({ url:'/feedback/like', method:'POST', data:{ feedback_id: item.id } })
        .then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; item.likes=d.likes; item.liked_by_me=d.liked; const set = this._getLikedSet('fb_item'); if(d.liked){ set.add(item.id) } else { set.delete(item.id) } this._saveLikedSet('fb_item', set) })
        .catch(()=>{})
    },
    toggleLike(c){
      request_zzquant({ url:'/feedback/comment/like', method:'POST', data:{ comment_id: c.id } })
        .then(res => { const d=res.data&&res.data.data?res.data.data:{}; c.likes=d.likes; c.liked_by_me=d.liked; const set = this._getLikedSet('fb_comment'); if(d.liked){ set.add(c.id) } else { set.delete(c.id) } this._saveLikedSet('fb_comment', set) })
        .catch(() => {})
    },
     deleteComment(c){
       request_zzquant({ url:'/feedback/comment/delete', method:'POST', data:{ comment_id: c.id } })
         .then(()=>{ this.loadList() })
         .catch(()=>{})
     },
    fullUrl(url){ if(!url){ return '' } if(url.startsWith('http')) return url; return 'https://api.zizizaizai.com' + url }
    }
  }
</script>

<style>
.thumb-icon{ width:16px; height:16px; vertical-align:middle; }
.list-thumb{ width:80px; height:80px; object-fit:cover; margin-right:6px; margin-bottom:6px; border:1px solid #eee; border-radius:4px; cursor:pointer; }
.preview-thumb{ width:100px; height:100px; object-fit:cover; margin-right:8px; margin-bottom:8px; border:1px solid #eee; border-radius:4px; cursor:pointer; }
.image-large{ max-width:100%; max-height:80vh; object-fit:contain; }
</style>
